import { TripPackageConfig } from './trip_packages';
import { TripCategoriesConfig } from './trip_categories';
import { ProductConfig } from './products';

export default {
	'trip_packages': TripPackageConfig,
	'products': ProductConfig,
	'trip_categories': TripCategoriesConfig
};
